const INITIAL_STATE = {
    userData: {
    },
    permissions: [],
    screens: []
};

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        case 'SET_USER_LOGIN_DATA': {
            return { ...state, userData: action.payload };
        }
        case "SET_USER_PERMISSIONS":
            return { ...state, permissions: action.payload };
        case "SET_USER_SCREENS":
            return { ...state, screens: action.payload };
        case 'SET_USER_LOGIN_DATA_EMAIL': {
            return {
                ...state,
                userData: {
                  ...state.userData,
                  email: action.payload
                }
              };
        }
        case 'SET_SECONDARY_EMAIL': {
            return {
                ...state,
                userData: {
                    ...state.userData,
                    secondary_email: action.payload
                }
            }
        }
        case 'SET_FIRST_ACCESS': {
            return {
                ...state,
                userData: {
                    ...state.userData,
                    first_access: action.payload
                }
            }
        }
        default:
            return state;
    }
}
